import React, { useEffect } from "react";
import CartHeader from "../Cart/CartHeader";
import OrderSummary from "./OrderSummary.jsx";
import creditcard from "../../../assets/credit-card.png";
import Delivery2 from "../../../assets/pickuplog.png";

import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import api from "../../../utils/api.js";
import { toast } from "react-toastify";
import { clearDiscount } from "../../../redux/promoSlice.js";
import { showCustomAlert } from "../Signup/Toast.jsx";
import { FaPoundSign } from "react-icons/fa";
import { useLocation } from "react-router-dom";

const Summary = () => {
  const navigate = useNavigate();
  
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  console.log("🚀 ~ Summary ~ user:", user)
  const { discount } = useSelector((state) => state.promo);
  const { cart } = useSelector((state) => state.cart);
  console.log("🚀 ~ Summary ~ cart:", cart)
  // console.log("🚀 ~ Summary ~ discount:", discount?.promoCode?.productId)

  const subtotal = cart.reduce((acc, item) => acc + item.basePrice * item.quantity, 0);
  const location = useLocation();
  const pointsSufficient = location.state?.pointsSufficient;

  // console.log("🚀 ~ Summary ~ pointsSufficient:", pointsSufficient);
  // Calculate discount amount
  // const discountAmount = discount ? (subtotal * discount.discount) / 100 : 0;
  // const totalPrice = subtotal-discountAmount

  // const subtotal = cart.reduce((total, item) => total + item.basePrice * item.quantity, 0);
  
  // Apply discount only on applicable products
  const discountAmount = cart.reduce((discountTotal, item) => {
    const isDiscountApplicable = discount?.promoCode?.productId?.includes(item._id); // Safe navigation
    console.log("🚀 ~ discountAmount ~ isDiscountApplicable:", isDiscountApplicable)
    if (isDiscountApplicable) {
      discountTotal += (item.basePrice * item.quantity * discount?.promoCode?.discount) / 100; // Apply discount
    }
    return discountTotal;
  }, 0);
  
  const totalPrice = subtotal - discountAmount;
  
  if (cart.length === 0) {
    return (
      <section className="flex flex-col self-center px-11 py-9 mt-12 rounded-lg bg-stone-50 w-[90%] max-md:px-5 max-md:mt-10">
        <h2 className="text-2xl font-bold text-black text-center">
          Your cart is empty.
        </h2>
        <p className="text-center text-gray-600 mt-2">
          Please add some items to your cart to view the order summary.
        </p>
      </section>
    );
  }
  const checkPointsAndCreateOrder = async () => {
    try {
      console.log("🚀 ~ Summary ~ pointsSufficient:", pointsSufficient); // Log to confirm the value
  
      // Check if points are sufficient
      if (pointsSufficient === true) {
        console.log("this case is runnign")
        // Points are sufficient, create the order directly
        await createOrder({
          userId: user._id,
          orderPrice: totalPrice,
          paymentMethod: "discount",
          transactionId: null, // No transaction ID required
          currency: null, // No currency required
          ispoint: true, // Mark this as a points-based order
        });
      } else  {
        // Points are not sufficient, check the payment status
        console.log("Triggering payment verification...");
        const response = await api.get(`/stripe/payment_intent/${user._id}`);
        const paymentStatus = response.data.paymentStatus;
        console.log("🚀 ~ Payment Status:", paymentStatus);
        const paymentIntentId = response.data.payment_intentId;
  
        if (paymentStatus === "succeeded") {
          // Payment succeeded, create the order
          await createOrder({
            userId: user._id,
            orderPrice: totalPrice,
            transactionId: paymentIntentId,
            currency: response.data.currency,
            paymentMethod: "Stripe",
            ispoint: false, // Not using points, so set it to false
          });
        } else {
          // Payment verification failed
          // toast.error("Payment verification failed. Please try again.");
        }
      } 
    } catch (error) {
      console.error("Error in points and payment check:", error);
      // toast.error("Your payment could not be processed. Please complete your payment to proceed.");

    }
  };
  
  

  const createOrder = async (paymentInfo) => {
    console.log("🚀 ~ createOrder ~ paymentInfo:", paymentInfo)
    const restaurantId = cart[0]?.restaurantId || JSON.parse(localStorage.getItem('selectedRestaurantId'));
    console.log("🚀 ~ restaurantId ~ restaurantId:", restaurantId);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
  
      // Determine if the order is paid with points or via another method
     
      const orderData = {
        userId: paymentInfo.userId,
        receiverPhone: user.phone || '0333333',
        receiverEmail: user.email,
        receiverName: user.name,
        paymentIntentId: paymentInfo.transactionId,
      
        items: cart.map((item) => ({
          productId: item.productId,
          quantity: item.quantity,
          type: item.type,
          categoryId: item.categoryId,
          name: item.name,
          basePrice: item.basePrice,
          image: item?.image ||item?.images[0] || null,
          description: item.description,
        })),
        totalPrice: paymentInfo.orderPrice, // Total price calculated
        offerId: null, // Add offer ID here if needed
        promoCodeId: null, // Add promo code ID if applicable
        restaurantId: restaurantId,
        orderType: "pickup", // Default or dynamically set
        paymentMethod: paymentInfo.paymentMethod, // Payment method (Stripe, Credit Card, etc.)
        cash: paymentInfo.orderPrice, // Cash used for payment
        ispoint: paymentInfo.ispoint, // Set ispoint flag based on payment method
      };
  
      console.log("🚀 ~ createOrder ~ orderData:", orderData);
  
      // Make the API call to create the order
     if(restaurantId){
      const orderResponse = await api.post(`/order`, orderData, config);
      const orderId = orderResponse?.data?.data?._id;
      if (orderId) {
        showCustomAlert({
          title: 'Order placed successfully!',
          html: '<p style="color: #555;">Your Order has been placed</p>',
          icon: 'success',
          confirmButtonText: 'view status',
          confirmButtonColor: '#af313d',
          background: '#ffffff',
          timer: 125000,
        });
        // toast.success("Order placed successfully!", {
        //   style: {
        //     backgroundColor: "white", // Background color
        //     color: "#AD343E", // Text color
        //   },
        //   icon: <span style={{ color: "#AD343E" }}>✔</span>, // Custom icon with red color
        // });
        // Navigate to the order status page with the orderId
        navigate(`/order-status/${orderId}`);
  
        // After successful order creation, record the transaction
        await createTransaction(paymentInfo, orderId);
  
        // Clear the discount when needed
        dispatch(clearDiscount());
  
        // Clear cart items and latest order from localStorage
        localStorage.setItem("cartItems", JSON.stringify([]));
        localStorage.setItem("latestOrder", JSON.stringify([]));
  
        // Optionally, reload the page if necessary
        window.location.reload();
      }
     }else {
      console.log('There is no restaurant')
     }
     
  
     
    } catch (error) {
      console.log("🚀 ~ createOrder ~ error:", error);
      if (error.response?.status === 500 && error.response?.data?.message.includes("duplicate key error")) {
         showCustomAlert({
                title: 'ly!',
                html: '<p style="color: #555;">This transaction has already been used.',
               
                icon: 'error',
                confirmButtonText: 'view status',
                confirmButtonColor: '#af313d',
                background: '#ffffff',
                timer: 125000,
              });
      } else {
          showCustomAlert({
                 title: 'ly!',
                 html: '<p style="color: #555;">This transaction has already been used.',
               
                 icon: 'error',
                 confirmButtonText: 'view status',
                 confirmButtonColor: '#af313d',
                 background: '#ffffff',
                 timer: 125000,
               });

        // toast.error("Your payment could not be processed. Please complete your payment to proceed.");

      }
    }
  };
  
  
 
  
  const createTransaction = async (paymentInfo, orderId) => {
    console.log("🚀 ~ createTransaction ~ orderId:", orderId)
    console.log("🚀 ~ createTransaction ~ paymentInfo:", paymentInfo);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
  
      const transactionData = {
        transactionId: paymentInfo.transactionId,
        userId: paymentInfo.userId,
        orderId: orderId, // Use the actual orderId from the createOrder response
        orderPrice: paymentInfo.orderPrice,
        isActive: true,
        currency: paymentInfo.currency,
        paymentMethod: paymentInfo.paymentMethod,
        confirm: true,
      };
  
      console.log("🚀 ~ createTransaction ~ transactionData:", transactionData);
  
      // Make the API call to create the transaction
      await api.post(`/transaction`, transactionData, config);
      toast.success("Transaction recorded successfully!", {
        style: {
          backgroundColor: "white", // Background color
          color: "#AD343E", // Text color
        },
        icon: <span style={{ color: "#AD343E" }}>✔</span>, // Custom icon with red color
      });
      
    } catch (error) {
      console.error("Error in transaction creation:", error);
      toast.error("An error occurred while recording the transaction.");
    }
  };
  return (
    <>
      <CartHeader />
      <div className="mt-8 flex justify-between lg:w-[310px] lg:h-[95px] w-[114.11px] h-[35.75px] sm:w-[114.11px] sm:h-[35.75px] md:w-[206.49px] md:h-[68.04px] bg-[#AF313D] rounded-full mx-auto mb-6 items-center">
        <div className="lg:w-[280px] lg:h-[83px] w-[104.11px] h-[30.75px] sm:w-[104.11px] sm:h-[30.75px] md:w-[196.49px] md:h-[58.04px] mx-auto   bg-white flex gap-4 items-center justify-center rounded-full">
          <img
            src={Delivery2}
            className=" lg:w-[53px] lg:h-[53px] w-[19.64px] h-[19.64px] sm:w-[19.64px] sm:h-[19.64px] md:w-[37.06px] md:h-[37.06px]"
            alt=""
          />
          <h1 className=" font-baloo font-bold lg:text-[30px] md:text-[20.98px] text-[11.11px] sm:text-[11.11px] text-[#000000]  lg:tracking-[.1rem]">
          Pick Up
          </h1>
        </div>
      </div>
      <div className=" mt-2  mb-4">
        <div className=" bg-gray-50 w-[90%] mx-auto shadow-sm">
          <h2 className="lg:text-[48px] text-[12.15px] sm:text-[12.15px] md:text-[27.96px] font-bold font-baloo mb-4 items-center flex justify-center md:py-4 md:pb-8">
            Order Summary
          </h2>
          <OrderSummary cartItems={cart} />
        </div>
      </div>
      <div className=" mt-2  mb-4 ">
        <div className=" w-[90%]  bg-gray-50 mx-auto shadow-lg rounded-sm">
          <div className=" flex items-center justify-center">
            <button className=" lg:w-[553px] lg:h-[71.63px] mt-5 lg:text-[40px] text-[15.14px] md:w-[386.54px] md:text-[27.96px] sm:text-[15.14px] sm:w-[167.88px] md:h-[49.63px] h-[21.55] sm:h-[21.55] w-[167.88px]  bg-[#AF313D] rounded-md text-white font-bold ">
              Personal Details
            </button>
          </div>
          <div className="px-4 flex flex-col gap-4 mt-8 ">
            <div className="flex justify-between items-center">
              <h1 className="font-baloo font-medium text-[#21203C] lg:text-[28.79px] text-[12.74px] sm:text-[12.74px] md:text-[20.12px]">
                Name
              </h1>
              <h1 className=" font-baloo font-semibold lg:text-[28.55px] text-[#21203C] md:text-[20.15px] text-[12.74px] sm:text-[12.74px]">
                {user.name}
              </h1>
            </div>
            <div className="flex justify-between items-center">
              <h1 className="font-baloo font-medium text-[#21203C] lg:text-[28.79px] text-[12.74px] sm:text-[12.74px] md:text-[20.12px]">
                Email
              </h1>
              <h1 className="font-baloo font-semibold lg:text-[28.55px] text-[#21203C] md:text-[20.15px] sm:text-[10.49px] text-[10.49px]">
               {user.email}
              </h1>
            </div>{" "}
            <div className="flex justify-between items-center">
              <h1 className="font-baloo font-medium text-[#21203C] lg:text-[28.79px] text-[12.74px] sm:text-[12.74px] md:text-[20.12px]">
                Phone Number
              </h1>
              <h1 className="font-baloo font-semibold lg:text-[28.55px] text-[#21203C] md:text-[20.15px] sm:text-[10.49px] text-[10.49px]">
                {user.contact || ""}
              </h1>
            </div>{" "}
         
          </div>
        </div>
      </div>
      <div className=" mt-2  mb-4">
        <div className=" w-[90%] mx-auto shadow-lg rounded-sm bg-gray-50">
          
          <div className=" flex items-center justify-center mt-8">
            <button className=" lg:w-[553px] lg:h-[71.63px] mt-5 lg:text-[40px] text-[15.14px] md:w-[386.54px] md:text-[27.96px] sm:text-[15.14px] sm:w-[167.88px] md:h-[49.63px] h-[21.55] sm:h-[21.55] w-[167.88px]  bg-[#AF313D] rounded-md text-white font-bold ">
              Order Summary
            </button>
          </div>
          <section className="flex flex-col self-center px-4 md:py-9 md:mt-8  rounded-lg bg-stone-50   max-md:px-5 max-md:mt-10 ">
            <div className="flex justify-between items-center">
              <div className=" flex flex-col md:leading-[64px] leading-[40px]">
                {cart.map((item, index) => (
                  <div
                    key={index}
                    className={`
             rotate-[3.469446951953614e-18rad] font-baloo font-medium text-[#000000] text-[12.74px] sm:text-[12.74px] md:text-[17.48px] lg:text-[25px]`}
                  >
                    {item.name}
                  </div>
                ))}
              </div>
              <div className="flex flex-col self-end  font-semibold whitespace-nowrap md:leading-[64px] leading-[40px] text-slate-800 ">
                {cart.map((item, index) => (
                  <div
                    key={index}
                    className="rotate-[9.19348695318866e-19rad] text-[12.74px] sm:text-[12.74px] md:text-[20.98px] font-baloo font-semibold lg:text-[30px]  "
                  >
                   <div className="flex items-center ">
  <FaPoundSign className="mr-1" />{item.basePrice*item.quantity}
  </div>
                  </div>
                ))}
              </div>
            </div>
            <hr className="shrink-0 mt-1.5 ml-4 w-full border-rose-700 border-solid border-[2px] max-w-[98%]" />

            <div className=" mt-4 flex  flex-col">
              <div className="flex justify-between items-center text-center">
                <div className=" font-baloo font-bold lg:text-[22px] text-[12.74px] sm:text-[12.74px] md:text-[16.78px]">
                  Subtotal
                </div>
                <div className=" lg:text-[34px] font-bold text-[12.74px] sm:text-[12.74px] md:text-[20.98px]">
                <div className="flex items-center ">
  <FaPoundSign className="mr-1" />{subtotal}
  </div>
                </div>
              </div>
              <div className="flex justify-between mt-4">
                <div className=" text-[#C97C2A] font-baloo font-bold lg:text-[30px] text-[12.74px] sm:text-[12.74px] md:text-[20.98px] ">
                  Total
                </div>
                <div className=" text-[#C97C2A] font-baloo font-bold text-[12.74px] sm:text-[12.74px] lg:text-[40px] md:text-[27.97px]">
                <div className="flex items-center ">
  <FaPoundSign className="mr-1" />{totalPrice}
  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className=" w-[70%] sm:px-8 px-8 md:px-16 flex justify-between items-center ">
        <Link to="/delivery">
          <button className=" flex items-center  justify-center lg:w-[121.19px] md:w-[84.58px] md:h-[34.1px] w-[52.95px] h-[21.35px] sm:w-[52.95px] sm:h-[21.35px] lg:h-[48.79px] bg-[white] px-2 py-2 lg:mt-8  text-[#AF313D] border-[#AF313D]  shadow-md mt-2  text-[7.4px] sm:text-[7.4px] lg:text-[16.91px] font-baloo font-semibold rounded-[2rem] md:text-[11.82px] mb-3">
            Back
          </button>
        </Link>
       <button  onClick={checkPointsAndCreateOrder} className=" flex items-center justify-center lg:w-[258.19px] md:w-[180.41px] md:h-[52.44px] w-[132.74px] h-[29.28px] sm:w-[132.74px] sm:h-[29.28px] lg:h-[75px] bg-[#AF313D] px-2 py-2 lg:mt-8 text-white  shadow-md mt-2  text-[15.43px] sm:text-[15.43px] lg:text-[26px] font-baloo font-semibold rounded-[2rem] md:text-[18.18px] mb-3">
          Place Order
        </button>
      </div>
    </>
  );
};

export default Summary;
